// src/pages/Home.js
import React, { useState, useEffect } from "react";
import "../App.css";
import Team3 from "../images/Team3.jpg";
import Fans1 from "../images/Fans1.jpg";
import Celebrate3 from "../images/Celebrate3.jpg";
import Fans2 from "../images/Fans2.jpg";
import { FaInstagram, FaTwitter, FaFacebook } from "react-icons/fa";
import CountdownTimer from "../components/CountdownTimer";
import { schedule } from "../pages/Schedule";

export default function Home() {
  const images = [Team3, Fans1, Celebrate3, Fans2];
  const [currentImage, setCurrentImage] = useState(0);
  const [fade, setFade] = useState(true);

  // Smooth slideshow transitions
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentImage((prev) => (prev + 1) % images.length);
        setFade(true);
      }, 700);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="home-page">
      <div
        className="home-background"
        style={{
          backgroundImage: `url(${images[currentImage]})`,
          opacity: fade ? 1 : 0,
        }}
      ></div>

      <div className="home-overlay-box">
        <h1 className="home-title">Pottsboro Basketball</h1>
        <p className="home-subtitle">ARETE</p>

        <CountdownTimer schedule={schedule} />

        <div className="social-section">
          <p className="follow-text">Follow Us</p>
          <div className="social-icons">
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
